export const ICONS = [
	'add-o',
	'add-square',
	'add',
	'after-sale',
	'aim',
	'alipay',
	'apps-o',
	'arrow-down',
	'arrow-left',
	'arrow-up',
	'arrow',
	'ascending',
	'audio',
	'award-o',
	'award',
	'bag-o',
	'bag',
	'balance-list-o',
	'balance-list',
	'balance-o',
	'balance-pay',
	'bar-chart-o',
	'bars',
	'bell',
	'bill-o',
	'bill',
	'birthday-cake-o',
	'bookmark-o',
	'bookmark',
	'browsing-history-o',
	'browsing-history',
	'brush-o',
	'bulb-o',
	'bullhorn-o',
	'calender-o',
	'card',
	'cart-circle-o',
	'cart-circle',
	'cart-o',
	'cart',
	'cash-back-record',
	'cash-on-deliver',
	'cashier-o',
	'certificate',
	'chart-trending-o',
	'chat-o',
	'chat',
	'checked',
	'circle',
	'clear',
	'clock-o',
	'clock',
	'close',
	'closed-eye',
	'cluster-o',
	'cluster',
	'column',
	'comment-circle-o',
	'comment-circle',
	'comment-o',
	'comment',
	'completed',
	'contact',
	'coupon-o',
	'coupon',
	'credit-pay',
	'cross',
	'debit-pay',
	'delete',
	'descending',
	'description',
	'desktop-o',
	'diamond-o',
	'diamond',
	'discount',
	'ecard-pay',
	'edit',
	'ellipsis',
	'empty',
	'envelop-o',
	'exchange',
	'expand-o',
	'expand',
	'eye-o',
	'eye',
	'fail',
	'failure',
	'filter-o',
	'fire-o',
	'fire',
	'flag-o',
	'flower-o',
	'free-postage',
	'friends-o',
	'friends',
	'gem-o',
	'gem',
	'gift-card-o',
	'gift-card',
	'gift-o',
	'gift',
	'gold-coin-o',
	'gold-coin',
	'good-job-o',
	'good-job',
	'goods-collect-o',
	'goods-collect',
	'graphic',
	'home-o',
	'hot-o',
	'hot-sale-o',
	'hot-sale',
	'hot',
	'hotel-o',
	'idcard',
	'info-o',
	'info',
	'invition',
	'label-o',
	'label',
	'like-o',
	'like',
	'live',
	'location-o',
	'location',
	'lock',
	'logistics',
	'manager-o',
	'manager',
	'map-marked',
	'medel-o',
	'medel',
	'more-o',
	'more',
	'music-o',
	'music',
	'new-arrival-o',
	'new-arrival',
	'new-o',
	'new',
	'newspaper-o',
	'notes-o',
	'orders-o',
	'other-pay',
	'paid',
	'passed',
	'pause-circle-o',
	'pause-circle',
	'pause',
	'peer-pay',
	'pending-payment',
	'phone-circle-o',
	'phone-circle',
	'phone-o',
	'phone',
	'photo-o',
	'photo',
	'photograph',
	'play-circle-o',
	'play-circle',
	'play',
	'plus',
	'point-gift-o',
	'point-gift',
	'points',
	'printer',
	'qr-invalid',
	'qr',
	'question-o',
	'question',
	'records',
	'refund-o',
	'replay',
	'scan',
	'search',
	'send-gift-o',
	'send-gift',
	'service-o',
	'service',
	'setting-o',
	'setting',
	'share',
	'shop-collect-o',
	'shop-collect',
	'shop-o',
	'shop',
	'shopping-cart-o',
	'shopping-cart',
	'shrink',
	'sign',
	'smile-comment-o',
	'smile-comment',
	'smile-o',
	'smile',
	'star-o',
	'star',
	'stop-circle-o',
	'stop-circle',
	'stop',
	'success',
	'thumb-circle-o',
	'thumb-circle',
	'todo-list-o',
	'todo-list',
	'tosend',
	'tv-o',
	'umbrella-circle',
	'underway-o',
	'underway',
	'upgrade',
	'user-circle-o',
	'user-o',
	'video-o',
	'video',
	'vip-card-o',
	'vip-card',
	'volume-o',
	'volume',
	'wap-home',
	'wap-nav',
	'warn-o',
	'warning-o',
	'warning',
	'weapp-nav',
	'wechat',
	'youzan-shield',
]
